import { PropsRange } from 'react-day-picker';
import { addDays, differenceInDays, isAfter, isBefore, isSameDay } from 'date-fns';

type HoverRangeInputProps = {
  selected: PropsRange['selected'];
  max: PropsRange['max'];
  hoveredDay: Date | null;
};
const getClampedHoverRange = (from: Date, hovered: Date, max: number) => {
  const diff = differenceInDays(hovered, from);
  const isNegative = diff < 0;
  const absDiff = Math.abs(diff);

  // Clamp the end date to the max allowed distance
  const limitedHover = absDiff > max ? addDays(from, isNegative ? -max : max) : hovered;

  const start = isNegative ? limitedHover : from;
  const end = isNegative ? from : limitedHover;

  return { start, end };
};
// Now your functions become trivial:
export const isHoverRangeMiddle =
  ({ selected, max = Infinity, hoveredDay }: HoverRangeInputProps) =>
  (day: Date) => {
    if (!selected?.from || !hoveredDay || (selected.from && selected.to)) {
      return false;
    }

    const { start, end } = getClampedHoverRange(selected.from, hoveredDay, max);
    // Middle is between start and end, excluding the boundaries
    return isAfter(day, start) && isBefore(day, end);
  };
export const isHoverRangeStart =
  ({ selected, max = Infinity, hoveredDay }: HoverRangeInputProps) =>
  (day: Date) => {
    if (!selected?.from || !hoveredDay || (selected.from && selected.to)) {
      return false;
    }

    const { start } = getClampedHoverRange(selected.from, hoveredDay, max);
    return isSameDay(day, start);
  };
export const isHoverRangeEnd =
  ({ selected, max = Infinity, hoveredDay }: HoverRangeInputProps) =>
  (day: Date) => {
    if (!selected?.from || !hoveredDay || (selected.from && selected.to)) {
      return false;
    }

    const { end } = getClampedHoverRange(selected.from, hoveredDay, max);
    return isSameDay(day, end);
  };
